import React, {useEffect, useState} from "react";
import "./MainGasFlame.css";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


function FuelOilFlame({

  PT_2105 = 0,   // Fuel Oil
  PT_2106 = 0,   // Atomizer

  x = 200,
  y = 200,

  width = 260,
  height = 220,

}) {


const [flameOn,setFlameOn] = useState(false);



/* ======================================
   PRESSURE VALUES
====================================== */

const fuelOil =
Number(PT_2105) || 0;


const atomizer =
Number(PT_2106) || 0;



/* ======================================
   FUEL CONDITION
====================================== */

const fuelAvailable =
fuelOil > 0.05;



/*
 Atomizer relationship

 Fuel oil max = 0.970
 Atomizer max = 1.299

 Good atomization:
 approx equal range

*/


const atomizerRatio =
fuelOil > 0
?
atomizer / fuelOil
:
0;




/* ======================================
   FLAME QUALITY
====================================== */


/*
 low atomizer:
 scattered flame


 good atomizer:
 smooth flame


 excessive atomizer:
 flame collapse

*/


const goodAtomization =
(
 atomizerRatio >= 0.4 &&
 atomizerRatio <= 2.0
);



const excessiveAtomizer =
(
 atomizerRatio > 3
);



useEffect(()=>{


if(
 fuelAvailable &&
 !excessiveAtomizer
){

setFlameOn(true);

}


else{

setFlameOn(false);

}


},[
fuelAvailable,
excessiveAtomizer
]);






/* =================================================
   SAVE MAIN FLAME STATUS
================================================= */

useEffect(() => {

    PlantStore.set({

        transmitters: {

            ...PlantStore.get().transmitters,

            FLAME_ON: flameOn

        }

    });

}, [flameOn]);




/* ======================================
   FLAME SIZE
====================================== */


const fuelLevel =
Math.max(

0,

Math.min(

(fuelOil - 0.05)
/
(0.970 - 0.05),

1

)

);



const flameHeight =
0.35 +
fuelLevel * 0.65;




const flameWidth =
goodAtomization
?
0.55 + fuelLevel*0.45
:
0.9 + fuelLevel*0.8;




/*
 unstable flame movement

 low atomizer = scattered
*/

const scatter =
goodAtomization
?
0
:
8;



const flameMoveY =
height -
(
height * flameHeight
);






return (


<div

style={{

position:"absolute",

left:x,

top:y,

width,

height,

zIndex:500,

pointerEvents:"none"

}}

>



<svg

width={width}

height={height}

viewBox="0 0 120 220"

>



<defs>


<radialGradient id="oilOuter">


<stop
offset="0%"
stopColor="#ffff66"
/>


<stop
offset="45%"
stopColor="#ff9900"
/>


<stop
offset="100%"
stopColor="#ff3300"
/>


</radialGradient>




<radialGradient id="oilInner">


<stop
offset="0%"
stopColor="white"
/>


<stop
offset="100%"
stopColor="#ffff00"
/>


</radialGradient>



</defs>





{

flameOn &&


<g


className="main-flame"


style={{


transformOrigin:"60px 220px",



transform:


`

translateY(${flameMoveY}px)

translateX(${scatter}px)

scale(

${flameWidth},

${flameHeight}

)

`


}}


>




{/* OUTER OIL FLAME */}



<path

d="

M60 220

C25 180 20 130 55 80

C35 45 80 20 70 0

C120 65 115 145 90 190

C80 210 65 220 60 220Z

"

fill="url(#oilOuter)"


/>






{/* HOT CORE */}



<path

d="

M60 210

C45 170 55 130 70 90

C95 150 90 180 75 205

C70 212 65 215 60 210Z

"

fill="url(#oilInner)"


/>





</g>


}



</svg>



</div>


);


}


export default FuelOilFlame;